var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.8C0 10.64 10.64 0 23.8 0C36.96 0 47.6 10.64 47.6 23.8C47.6 36.96 36.96 47.6 23.8 47.6C10.64 47.6 0 36.96 0 23.8ZM44.8 23.8C44.8 12.18 35.42 2.8 23.8 2.8C12.18 2.8 2.8 12.18 2.8 23.8C2.8 35.42 12.18 44.8 23.8 44.8C35.42 44.8 44.8 35.42 44.8 23.8Z",
    fill: "#658479"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4194 35.4197L33.0394 23.7997L21.4194 12.1797L23.3794 10.2197L36.9594 23.7997L23.3794 37.3797L21.4194 35.4197Z",
    fill: "#658479"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9984 22.3994V25.1994H11.1984V22.3994H34.9984Z",
    fill: "#658479"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextBtn);
export default __webpack_public_path__ + "static/media/NextBtn.b0383936138ff45591ebc2c417fe80f5.svg";
export { ForwardRef as ReactComponent };